import * as tslib_1 from "tslib";
import { computed } from 'mobx';
import MailListGroupHeader from './MailListGroupHeader';
import MailListItemDataProvider from './MailListItemDataProvider';
import MailListLoading from './MailListLoading';
import getMailListTableProps from '../utils/getMailListTableProps';
import { observer } from 'mobx-react';
import Draggable from 'owa-dnd/lib/components/Draggable';
import { isGroupTableQuery } from 'owa-group-common';
import { keydownHandler } from 'owa-hotkeys';
import LoadMoreListView from 'owa-loadmore-listview/lib/components/LoadMoreListView';
import { resetFocus, tabIndex } from 'owa-mail-focus-manager';
import * as MailModuleAutoFocusManager from 'owa-mail-focus-manager/lib/mailModuleAutoFocusManager';
import { focusedInboxRollupStore } from 'owa-mail-focused-inbox-rollup-store';
import { FocusedInboxRollup, shouldShowFocusedRollup } from 'owa-mail-focused-inbox-rollup-view';
import { getCommands } from 'owa-mail-hotkeys';
import loadMoreInTable from 'owa-mail-list-actions/lib/actions/table/loadMoreInTable';
import getMailListRowDragData from 'owa-mail-list-store/lib//utils/getMailListRowDragData';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import * as markReadActions from 'owa-mail-mark-read-actions';
import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { messageAdListViewStatusStore } from 'owa-mail-messagead-list-store';
import { MessageAdList } from 'owa-mail-messagead-list-view';
import isReadingPaneBottom from 'owa-mail-reading-pane-store/lib/utils/isReadingPaneBottom';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import mailStore from 'owa-mail-store/lib/store/Store';
import { getCanTableLoadMore } from 'owa-mail-table-loading-actions';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { doesUserHaveSharedFolderPermissionFor, } from 'owa-mail-filterable-menu-behavior';
import { multiSelectNextRow, multiSelectPreviousRow, selectNextRow, selectPreviousRow, toggleSelectAllRows, singleSelectRow, resetSelection, } from 'owa-mail-actions';
import { getMailListGroupHeader, getMailListGroupHeaderGenerator, } from 'owa-mail-list-group-headers';
import { getNativeAdInitialPlacement } from 'owa-mail-ads-shared';
import { lazyForwardConversation, lazyReplyToConversation, lazyForwardItem, lazyReplyToItem, } from 'owa-mail-message-actions';
import { getMailListRowDragPreview, MAIL_ITEM_DRAG_XOFFSET, MAIL_ITEM_DRAG_YOFFSET, } from '../utils/mailListDragUtil';
import { getFocusedFilterForTable, getIsEverythingSelectedInTable, listViewStore, MailRowDataPropertyGetter, } from 'owa-mail-list-store';
import { lazyArchiveMailListRows, lazyDeleteMailListRows, lazyEmptyTableView, lazyMarkRowsJunkNotJunk, lazyToggleRowsFlagState, } from 'owa-mail-triage-action';
var styles = require('./MailList.scss');
var classNames = require('classnames');
var MailListContent = /** @class */ (function (_super) {
    tslib_1.__extends(MailListContent, _super);
    function MailListContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusOnSelfOnComponentUpdate = function () {
            // If the listview loads without cached content, only MailList is displayed.
            // When the mail list content gets rendered layer, it needs to transfer focus from MailList to MailListContent
            // to support keyboard navigation.
            window.requestAnimationFrame(function () {
                if (_this.props.isFocusOnMailList()) {
                    _this.trySetFocus();
                }
            });
        };
        /**
         * Handles scroll on list pane hidden / shown
         */
        _this.handleScrollPositionOnShowHideListPane = function (currentTableViewId) {
            var currentShowListPane = mailStore.mailModule.showListPane;
            // When list pane changes from shown to hidden, it means we have gone into immersive reading pane and we need to
            // save current scroll position for if user exits and goes back to same list pane (in same table). When user
            // exits immersive reading pane and returns to the same table / previously shown list pane which changes list pane
            // from hidden to shown, we need to restore scroll position to where user was before going into immersive.
            // If user goes to a different table from immersive, then we do not restore scroll position as it should be reset to top.
            if (_this.lastShowListPane !== null &&
                _this.lastShowListPane !== currentShowListPane &&
                _this.lastTableViewId === currentTableViewId) {
                if (currentShowListPane) {
                    _this.listView.restoreSavedScrollPosition();
                }
                else {
                    _this.listView.storeScrollPosition();
                }
                resetFocus();
            }
            _this.lastShowListPane = currentShowListPane;
            _this.lastTableViewId = currentTableViewId;
        };
        _this.getCanCurrentTableLoadMore = function () {
            return getCanTableLoadMore(_this.getTableView());
        };
        /*
        We should show the message Ad list when all of the following conditions are true:
        1. When the view is in the other pivot, native ads will be shown either OtherInboxOnly or AllInbox flight is on
        2. When any all inbox flight is on, AllInbox flight needs to be on
        3. Search does not run
        4. listRemoved is not true in message ad list view status store. This means the message Ad list is not removed by the user manually in this session
        */
        _this.shouldShowMessageAdList = function (tableView) {
            if (messageAdListViewStatusStore && messageAdListViewStatusStore.listRemoved) {
                return false;
            }
            return ((getFocusedFilterForTable(tableView) == 1 /* Other */ &&
                (getNativeAdInitialPlacement() == 1 /* OtherOnly */ ||
                    getNativeAdInitialPlacement() == 2 /* OtherPrefer */)) ||
                (tableView.tableQuery.folderId == folderNameToId('inbox') &&
                    tableView.tableQuery.type != 1 /* Search */ &&
                    (getNativeAdInitialPlacement() == 3 /* AllInbox */ ||
                        (getNativeAdInitialPlacement() == 2 /* OtherPrefer */ &&
                            !isFocusedInboxEnabled()))));
        };
        _this.onLoadMoreRows = function () {
            loadMoreInTable(_this.getTableView());
        };
        _this.createMailListItem = function (rowKey, itemIndex, listProps) {
            return (React.createElement(MailListItemDataProvider, { key: rowKey, rowKey: rowKey, mailListTableProps: listProps, resetListViewContentTabIndex: _this.resetListViewContentTabIndex, isFocusInMailList: _this.props.isFocusInMailList }));
        };
        /**
         * Clear tabindex of container such that container is not in a sequential
         * keyboard navigation when an item is selected in listview
         */
        _this.resetListViewContentTabIndex = function () {
            if (_this.mailListViewContent.getAttribute('tabindex') == tabIndex.sequentialIndex) {
                _this.mailListViewContent.setAttribute('tabindex', tabIndex.nonSequentialIndex);
            }
        };
        _this.createHeader = function (previousRowKey, currentRowKey) {
            var headers = [];
            var headerText = getMailListGroupHeader(previousRowKey, currentRowKey, _this.getTableView(), _this.mailListGroupHeaderGenerator);
            if (headerText) {
                headers.push(React.createElement(MailListGroupHeader, { key: "gh_" + headerText, headerText: headerText }));
            }
            if (shouldShowFocusedRollup(previousRowKey, currentRowKey)) {
                headers.push(React.createElement(FocusedInboxRollup, { key: "rollup", rollupState: focusedInboxRollupStore }));
            }
            return headers.length > 0 ? React.createElement("div", { key: 'header_' + currentRowKey }, headers) : null;
        };
        _this.trySetFocus = function () {
            if (_this.mailListViewContent) {
                _this.mailListViewContent.focus();
                return true;
            }
            return false;
        };
        _this.getTableView = function () {
            return listViewStore.tableViews.get(_this.props.tableViewId);
        };
        _this.canDrag = function () {
            return getMailListTableProps(_this.props.tableViewId).canDragFromTable;
        };
        return _this;
    }
    MailListContent.prototype.componentDidMount = function () {
        // Trigger focus if necessary after mount
        this.focusOnSelfOnComponentUpdate();
    };
    MailListContent.prototype.componentWillUpdate = function () {
        var tableView = this.getTableView();
        // tableView will be null if user deleted the folder while it was selected
        if (tableView && tableView.currentRowOperation == 2 /* RowMove */) {
            // If we're in the process of doing a row move, we must store the current scroll position before component
            // updates, as React will handle row moves in a way that will cause the listview to jump.
            this.listView.storeScrollPosition();
        }
    };
    MailListContent.prototype.componentDidUpdate = function () {
        var tableView = this.getTableView();
        // tableView will be null if user deleted the folder while it was selected
        if (tableView && tableView.currentRowOperation == 2 /* RowMove */) {
            // If we're in the process of doing a row move, we must restore the scroll position after component updates,
            // as React will handle row moves in a way that will cause the listview to jump.
            this.listView.restoreSavedScrollPosition();
        }
        // Trigger focus if necessary after component update
        this.focusOnSelfOnComponentUpdate();
    };
    MailListContent.prototype.componentWillUnmount = function () {
        if (this.props.isFocusInMailList) {
            // Reset focus such that it can be restored when component is updated
            resetFocus();
        }
    };
    Object.defineProperty(MailListContent.prototype, "mailListTableProps", {
        get: function () {
            return getMailListTableProps(this.props.tableViewId);
        },
        enumerable: true,
        configurable: true
    });
    MailListContent.prototype.renderListViewContent = function () {
        var _this = this;
        var tableView = this.getTableView();
        var listProps = this.mailListTableProps;
        this.mailListGroupHeaderGenerator = getMailListGroupHeaderGenerator(tableView);
        // Ensure scroll position is maintained on show/hide listview
        this.handleScrollPositionOnShowHideListPane(tableView.id);
        // watch date rollover to re-render listivew
        mailStore.todayDate;
        // Warning: this.getScrollRegionClassNames() must be assigned to LoadMoreListView in order for the LoadMoreListView
        // to get proper onscroll events. Please keep this in mind when trying to refactor the DOM layers here.
        var loadMoreListView = (React.createElement("div", { tabIndex: 0, role: "listbox", "aria-label": strings.messageListAriaLabel, ref: function (ref) { return (_this.mailListViewContent = ref); }, className: styles.wrapperDiv },
            React.createElement(LoadMoreListView, { ref: function (ref) { return (_this.listView = ref); }, className: this.getScrollRegionClassNames(), dataSourceId: tableView.id, itemIds: tableView.rowKeys, onScroll: this.props.onScroll, onRenderRow: this.createMailListItem, onRenderHeader: this.createHeader, onLoadMoreRows: this.onLoadMoreRows, isLoadRowsInProgress: tableView.isLoading, getCanLoadMore: this.getCanCurrentTableLoadMore, currentLoadedIndex: tableView.currentLoadedIndex, guardPageCount: 3, loadingComponent: this.renderLoadingSpinner(), rowWrapperClass: styles.rowWrapper, preRowsComponent: this.shouldShowMessageAdList(tableView) && React.createElement(MessageAdList, null), postRowsComponent: this.renderSpinnerPlaceholder(), listProps: listProps })));
        return loadMoreListView;
    };
    MailListContent.prototype.getScrollRegionClassNames = function () {
        return classNames('customScrollBar', styles.outerScrollContainer);
    };
    MailListContent.prototype.renderLoadingSpinner = function () {
        // Do not render the loading spinner if the table cannot load more. If the table is in loading state but cannot load more,
        // it indicates it's doing a reload in which case we don't want to show the load more spinner.
        return this.getCanCurrentTableLoadMore() ? React.createElement(MailListLoading, null) : null;
    };
    MailListContent.prototype.renderSpinnerPlaceholder = function () {
        var tableView = this.getTableView();
        // Do not show the placeholder if we're loading and showing the spinner, or this table
        // cannot load more which means the spinner won't ever appear.
        if (tableView.isLoading || !this.getCanCurrentTableLoadMore()) {
            return null;
        }
        // Create an element to render after all rows that take up the same space as the loading indicator,
        // so that the height of the scroll region doesn't change when loading indicator appears
        return React.createElement("div", { className: styles.spinnerPlaceHolder });
    };
    MailListContent.prototype.render = function () {
        return (React.createElement(Draggable, { canDrag: this.canDrag, getDragData: getMailListRowDragData, getDragPreview: getMailListRowDragPreview, xOffset: MAIL_ITEM_DRAG_XOFFSET, yOffset: MAIL_ITEM_DRAG_YOFFSET, classNames: styles.draggableDiv }, this.renderListViewContent()));
    };
    /**
     * Hot keys
     */
    MailListContent.prototype.selectNextRow = function () {
        var tableView = this.getTableView();
        selectNextRow(tableView, MailListItemSelectionSource.KeyboardUpDown);
    };
    MailListContent.prototype.keyboardShiftMultiSelectNextRow = function () {
        multiSelectNextRow(this.getTableView(), MailListItemSelectionSource.KeyboardUpDown, false /* isCtrlDown */);
    };
    MailListContent.prototype.keyboardCtrlShiftMultiSelectNextRow = function () {
        multiSelectNextRow(this.getTableView(), MailListItemSelectionSource.KeyboardUpDown, true /* isCtrlDown */);
    };
    MailListContent.prototype.selectPrevRow = function () {
        var tableView = this.getTableView();
        selectPreviousRow(tableView, MailListItemSelectionSource.KeyboardUpDown);
    };
    MailListContent.prototype.multiselectPrevRow = function () {
        multiSelectPreviousRow(this.getTableView(), MailListItemSelectionSource.KeyboardUpDown, false /* isCtrlDown */);
    };
    MailListContent.prototype.keyboardCtrlShiftMultiSelectPreviousRow = function () {
        multiSelectPreviousRow(this.getTableView(), MailListItemSelectionSource.KeyboardUpDown, true /* isCtrlDown */);
    };
    MailListContent.prototype.selectAll = function () {
        var tableView = this.getTableView();
        var isEverythingSelectedBeforeToggle = getIsEverythingSelectedInTable(tableView);
        if (!isEverythingSelectedBeforeToggle) {
            toggleSelectAllRows(tableView);
        }
    };
    // deselectAll is tied to esc key in certain key sets
    // We stop propagation only when we toggleCheckAll, else
    // we let the event to propagate
    MailListContent.prototype.deselectAll = function () {
        var tableView = this.getTableView();
        var isEverythingSelectedBeforeToggle = getIsEverythingSelectedInTable(tableView);
        if (isEverythingSelectedBeforeToggle) {
            toggleSelectAllRows(tableView);
        }
        else {
            resetSelection(tableView, MailListItemSelectionSource.Reset);
        }
    };
    MailListContent.prototype.openMail = function () {
        var tableView = this.getTableView();
        var selectedRowIds = tslib_1.__spread(tableView.selectedRowKeys.keys());
        if (selectedRowIds.length == 1) {
            singleSelectRow(tableView, selectedRowIds[0], true /* isUserNavigation */, MailListItemSelectionSource.KeyboardEnter);
        }
    };
    MailListContent.prototype.archiveRow = function () {
        var tableView = this.getTableView();
        // archiving is disabled for groups
        if (isGroupTableQuery(tableView.tableQuery)) {
            return;
        }
        lazyArchiveMailListRows.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, 'Keyboard');
    };
    MailListContent.prototype.markAsJunk = function () {
        var tableView = this.getTableView();
        // mark as junk is disabled for groups
        if (isGroupTableQuery(tableView.tableQuery)) {
            return;
        }
        lazyMarkRowsJunkNotJunk.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, true /* isJunkValueToSet */, 'Keyboard' /* actionSource */);
    };
    MailListContent.prototype.deleteRow = function () {
        this.deleteSelectedRow();
    };
    MailListContent.prototype.softDeleteRow = function () {
        this.deleteSelectedRow(true /*isSoftDelete*/);
    };
    MailListContent.prototype.markAsReadRow = function () {
        var tableView = this.getTableView();
        var isInVirtualSelectAllMode = tableView.isInVirtualSelectAllMode;
        var rowKeysToActOn = isInVirtualSelectAllMode
            ? []
            : tslib_1.__spread(tableView.selectedRowKeys.keys());
        var exclusionList = isInVirtualSelectAllMode
            ? tableView.virutalSelectAllExclusionList
            : [];
        markReadActions.lazyMarkAsReadInTable.importAndExecute('Keyboard', exclusionList, isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, true /* isReadValueToSet */, rowKeysToActOn, tableView);
    };
    MailListContent.prototype.markAsUnreadRow = function () {
        var tableView = this.getTableView();
        var isInVirtualSelectAllMode = tableView.isInVirtualSelectAllMode;
        var rowKeysToActOn = isInVirtualSelectAllMode
            ? []
            : tslib_1.__spread(tableView.selectedRowKeys.keys());
        var exclusionList = isInVirtualSelectAllMode
            ? tableView.virutalSelectAllExclusionList
            : [];
        markReadActions.lazyMarkAsReadInTable.importAndExecute('Keyboard', exclusionList, isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, false /* isReadValueToSet */, rowKeysToActOn, tableView);
    };
    MailListContent.prototype.toggleFlag = function () {
        // Disable flag toggling for shared folders if the user doesn't have the permission
        if (!doesUserHaveSharedFolderPermissionFor(8 /* Flag */)) {
            return;
        }
        var tableView = this.getTableView();
        // toggle flag is disabled for groups
        if (isGroupTableQuery(tableView.tableQuery)) {
            return;
        }
        lazyToggleRowsFlagState.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, 'Keyboard');
    };
    MailListContent.prototype.replyAllToRow = function () {
        var tableView = this.getTableView();
        var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
        // Only support reply all to a single row.
        // If it's multi selected, take no action
        if (selectedRowKeys.length != 1) {
            return;
        }
        var rowId = MailRowDataPropertyGetter.getRowClientItemId(selectedRowKeys[0], tableView);
        var instrumentationContexts;
        if (tableView.tableQuery.type == 1 /* Search */) {
            instrumentationContexts = getInstrumentationContextsFromTableView([selectedRowKeys[0]], tableView);
        }
        switch (tableView.tableQuery.listViewType) {
            case 0 /* Conversation */:
                lazyReplyToConversation.importAndExecute(rowId, true /*isReplyAll*/, 'Keyboard', instrumentationContexts, isReadingPaneBottom() /*isFullCompose*/);
                break;
            case 1 /* Message */:
                lazyReplyToItem.importAndExecute(rowId, true /* isReplyAll */, instrumentationContexts, 'Keyboard');
        }
    };
    MailListContent.prototype.replyToRow = function () {
        var tableView = this.getTableView();
        var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
        // Reply (little-r) is disabled for groups
        if (isGroupTableQuery(tableView.tableQuery)) {
            return;
        }
        // Only support reply to a single conversation.
        // If it's multi selected, take no action
        if (selectedRowKeys.length != 1) {
            return;
        }
        var rowId = MailRowDataPropertyGetter.getRowClientItemId(selectedRowKeys[0], tableView);
        var instrumentationContexts;
        if (tableView.tableQuery.type == 1 /* Search */) {
            instrumentationContexts = getInstrumentationContextsFromTableView([selectedRowKeys[0]], tableView);
        }
        switch (tableView.tableQuery.listViewType) {
            case 0 /* Conversation */:
                lazyReplyToConversation.importAndExecute(rowId, false /*isReplyAll*/, 'Keyboard', instrumentationContexts, isReadingPaneBottom() /*isFullCompose*/);
                break;
            case 1 /* Message */:
                lazyReplyToItem.importAndExecute(rowId, false /* isReplyAll */, instrumentationContexts, 'Keyboard');
                break;
        }
    };
    MailListContent.prototype.forwardRow = function () {
        var tableView = this.getTableView();
        var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
        // Only support forward a single row.
        // If it's multi selected, take no action
        if (selectedRowKeys.length != 1) {
            return;
        }
        var rowId = MailRowDataPropertyGetter.getRowClientItemId(selectedRowKeys[0], tableView);
        var instrumentationContexts;
        if (tableView.tableQuery.type == 1 /* Search */) {
            instrumentationContexts = getInstrumentationContextsFromTableView([selectedRowKeys[0]], tableView);
        }
        switch (tableView.tableQuery.listViewType) {
            case 0 /* Conversation */:
                lazyForwardConversation.importAndExecute(rowId, 'Keyboard', instrumentationContexts);
                break;
            case 1 /* Message */:
                lazyForwardItem.importAndExecute(rowId, 'Keyboard', instrumentationContexts);
                break;
        }
    };
    MailListContent.prototype.focusReadingPane = function () {
        MailModuleAutoFocusManager.setFocusTo(MailModuleAutoFocusManager.FocusComponent.ReadingPane);
    };
    /**
     * Delete seleted row in the current folder
     * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
     */
    MailListContent.prototype.deleteSelectedRow = function (isExplicitSoftDelete) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tableView;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.getTableView();
                        // Disable row deletion in groups or
                        // if the row is in a shared folder and user doesn't have delete permissions
                        if (tableView.tableQuery.type == 2 /* Group */ ||
                            !doesUserHaveSharedFolderPermissionFor(6 /* Delete */)) {
                            return [2 /*return*/];
                        }
                        if (!tableView.isInVirtualSelectAllMode) return [3 /*break*/, 2];
                        // When in virtual select all mode, i.e select all mode in non-search,
                        // delete all in the folder
                        return [4 /*yield*/, lazyEmptyTableView.importAndExecute(tableView, isExplicitSoftDelete, 'Keyboard', tableView.virutalSelectAllExclusionList)];
                    case 1:
                        // When in virtual select all mode, i.e select all mode in non-search,
                        // delete all in the folder
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, lazyDeleteMailListRows.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, isExplicitSoftDelete, 'Keyboard')];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (tableView.rowKeys.length == 0) {
                            // Set focus on the container such that it doesn't get
                            // lost when the deleted item is the last one in the current folder
                            resetFocus();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        computed
    ], MailListContent.prototype, "mailListTableProps", null);
    tslib_1.__decorate([
        keydownHandler('down', false /*stopPropagation*/)
    ], MailListContent.prototype, "selectNextRow", null);
    tslib_1.__decorate([
        keydownHandler('shift+down', false /*stopPropagation*/)
    ], MailListContent.prototype, "keyboardShiftMultiSelectNextRow", null);
    tslib_1.__decorate([
        keydownHandler('shift+ctrl+down', false /*stopPropagation*/)
    ], MailListContent.prototype, "keyboardCtrlShiftMultiSelectNextRow", null);
    tslib_1.__decorate([
        keydownHandler('up', false /*stopPropagation*/)
    ], MailListContent.prototype, "selectPrevRow", null);
    tslib_1.__decorate([
        keydownHandler('shift+up', false /*stopPropagation*/)
    ], MailListContent.prototype, "multiselectPrevRow", null);
    tslib_1.__decorate([
        keydownHandler('shift+ctrl+up', false /*stopPropagation*/)
    ], MailListContent.prototype, "keyboardCtrlShiftMultiSelectPreviousRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().selectAll, true /* stopPropagation */)
    ], MailListContent.prototype, "selectAll", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().deselectAll, true /* stopPropagation */)
    ], MailListContent.prototype, "deselectAll", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().openMail)
    ], MailListContent.prototype, "openMail", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().archiveMail)
    ], MailListContent.prototype, "archiveRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().markAsJunk)
    ], MailListContent.prototype, "markAsJunk", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().deleteMail)
    ], MailListContent.prototype, "deleteRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().softDeleteMail)
    ], MailListContent.prototype, "softDeleteRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().markAsRead)
    ], MailListContent.prototype, "markAsReadRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().markAsUnread)
    ], MailListContent.prototype, "markAsUnreadRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().toggleFlag)
    ], MailListContent.prototype, "toggleFlag", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().replyAll)
    ], MailListContent.prototype, "replyAllToRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().reply)
    ], MailListContent.prototype, "replyToRow", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().forward)
    ], MailListContent.prototype, "forwardRow", null);
    tslib_1.__decorate([
        keydownHandler('right')
    ], MailListContent.prototype, "focusReadingPane", null);
    MailListContent = tslib_1.__decorate([
        observer
    ], MailListContent);
    return MailListContent;
}(React.Component));
export default MailListContent;
//# sourceMappingURL=MailListContent.js.map